import { createSlice } from "@reduxjs/toolkit";
import { cableBuilder } from "./thunks";

export const initialState = {
    cables : [],
    cablesTags : [],
    cableActiveTag : localStorage.getItem('cableActiveTag') ? JSON.parse(localStorage.getItem('cableActiveTag')) : {name : 'Не выбрано', id : null},
    cablesTable : [],
    tableMarketplaceTags : [],
    tableVendorsTags : [],
    tableAliasTags : [],
    tableMarketActiveTags : [],
    tableVendorActiveTags : [],
    tableAliasActiveTags : [],
    error : null,
    isLoading : false
}


export const cableSlice = createSlice({
    name : 'cable',
    initialState,
    reducers : {
        setCablesFilter(state, action){
            state.cables = action.payload
        },
        setActiveTag(state, action){
            state.cableActiveTag = action.payload
            localStorage.setItem('cableActiveTag', JSON.stringify(action.payload))
        },
        setTableMarketplaceTags(state, action){
            state.tableMarketActiveTags = action.payload
        },
        setTableVendorsTags(state, action){
            state.tableVendorActiveTags = action.payload
        },
        setTableAliasTags(state, action){
            state.tableAliasActiveTags = action.payload
        }
    },
    extraReducers : cableBuilder
})

export const {setCablesFilter, setActiveTag, setTableMarketplaceTags, setTableVendorsTags, setTableAliasTags} = cableSlice.actions
export default cableSlice.reducer